import { call, put, putResolve, takeEvery } from 'redux-saga/effects';
import * as actions from '../../actions/utility-actions';
import { 
    BaseSagaRequest, 
    DeleteRequest, 
    GetRequest, 
    PostRequest, 
    PutRequest
} from '../../models/utilities/requests';
import { AppUtils } from '../../utils/app-utils';
import { navigateToPage } from '../../utils/history';
import { Mapper } from '../../utils/mapper';
import { ToastMessage } from "../../models/utilities/toast-message";

/**
 * Make a POST to the API
 * @param request The POST request to execute
 */
function* postFn(request : BaseSagaRequest) {
    const postReq = request as PostRequest;
    const rawResponse = yield putResolve(actions.fetch(postReq.url, 'POST', postReq.data));
    return rawResponse;
}

/**
 * Make a PUT to the API
 * @param request The PUT request to execute
 */
function* putFn(request : BaseSagaRequest) {
    const postReq = request as PutRequest;
    const rawResponse = yield putResolve(actions.fetch(postReq.url, 'PUT', postReq.data));
    return rawResponse;
}

/**
 * Make a GET to the API
 * @param request The GET request to execute
 */
function* getFn(request : BaseSagaRequest) {
    const getReq = request as GetRequest;
    const rawResponse = yield putResolve(actions.fetch(getReq.url, 'GET'));
    const resp = Mapper.deserialize(getReq.type, rawResponse);
    return resp;
}

/**
 * Make a DELETE to the API
 * @param request The DELETE request to execute
 */
function* deleteFn(request : BaseSagaRequest) {
    const deleteReq = request as DeleteRequest;
    const rawResponse = yield putResolve(actions.fetch(deleteReq.url, 'DELETE', {'rowVersion': deleteReq.rowVersion}));
    return rawResponse;
}

/**
 * Fetch, process, and update store for paged result
 * @param action The redux action
 */
export function* apiRequestWorker(action: IReduxAction) {

    const request = action.payload as BaseSagaRequest;
    yield put(actions.showLoading());

    try{

        let response : any;
        switch(request.verb){
            case 'GET':
                response = yield call(getFn, request);
                break;
            case 'POST':
                response = yield call(postFn, request);
                break;
            case 'PUT':
                response = yield call(putFn, request);
                break;
            case 'DELETE':
                response = yield call(deleteFn, request);
                break;
        }
        
        // Yield the success action with the payload
        yield put({ 
            type: request.successAction,
            payload: response
        });
        
        // If there's a navigate action on the request, navigate there
        if(request.navigate && request.navigate.length > 0) {
            yield call(navigateToPage, request.navigate);
        }

    }
    catch (err) {
        if(err){ 
            console.error(err);
            const errorMsg = AppUtils.FormatError(err);
            yield put(actions.showToastNotification(new ToastMessage(errorMsg, "error")));
        }
        
        yield put({
            type: request.failAction
        });

    }

    yield put(actions.hideLoading());
}

/**
 * Watch for messages to make paged get request
 */
export function* apiRequestWatcher() {
    yield takeEvery(actions.UTILITY_API_REQUEST, apiRequestWorker);
}

